module.exports = __webpack_public_path__ + "static/media/sound2.691d280.ogg";